module.exports = __webpack_public_path__ + "img/store_person_icon_red.e4cae787.svg";